import { QueryKey } from '@/configs/queryKeys';
import { Attachment, ObjectAvailability, Store, Translations } from '@/types/types';
import { AttributeValue } from './AttributeValueApi';
import EntityApi, { BaseEntity } from './EntityApi';
import { ProductModule } from './ProductModuleApi';

export interface ProductModuleCollectionStoreConfiguration {
	store: Store;
	listOrder: number;
	status: ObjectAvailability;
	description: string;
	shopUrl: string;
}

export interface ProductModuleCollection extends BaseEntity {
	name: string;
	code: string;
	listOrder: number;
	isActive: boolean;
	image?: Attachment;
	defaultAttributeValues: AttributeValue[];
	attributeValues: AttributeValue[];
	defaultModule: ProductModule;
	translations: Translations<{
		name: string;
	}>;
	storeConfiguration: ProductModuleCollectionStoreConfiguration;
}

class ProductModuleCollectionApi extends EntityApi<ProductModuleCollection> {
	constructor() {
		super(QueryKey.productModuleCollections);
	}
}

export default new ProductModuleCollectionApi();
